"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const models_1 = require("@osmosys/models");
const react_1 = tslib_1.__importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const react_loops_1 = require("react-loops");
const react_2 = require("@osmosys/react");
const react_select_1 = tslib_1.__importDefault(require("react-select"));
exports.FeatureFlagsForm = ({ featureFlagOverrides, onChange, }) => {
    const flags = react_1.useMemo(() => {
        return Object.assign(Object.assign({}, new models_1.FeatureFlags()), featureFlagOverrides);
    }, [featureFlagOverrides]);
    return (react_1.default.createElement(react_2.OsmosysDiv, { style: { marginBottom: 100 } },
        react_1.default.createElement(react_loops_1.For, { in: flags }, (featureFlag, { key }) => {
            const options = [
                {
                    label: 'N/A',
                    value: null,
                },
                { label: 'Off', value: false },
                { label: 'On', value: true },
            ];
            const value = options.find(opt => typeof featureFlag === 'boolean'
                ? opt.value === featureFlag
                : opt.value === null);
            if (key.startsWith('__')) {
                return null;
            }
            return (react_1.default.createElement(reactstrap_1.FormGroup, null,
                react_1.default.createElement(reactstrap_1.Label, null,
                    react_1.default.createElement(react_2.OsmosysChangeCase, null, `${key}`)),
                react_1.default.createElement(react_select_1.default, { value: value, options: options, onChange: (opt) => {
                        onChange(Object.assign(Object.assign({}, featureFlagOverrides), { [key]: opt.value }));
                    } })));
        })));
};
//# sourceMappingURL=FeatureFlagsForm.js.map